// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function Carousel() {

    var self          = this,
        $cache        = {},
        enableTouchMove = null,
        carousel      = null,
        carouselText  = null,
        carouselSwiper  = null,
        carouselTextSwiper  = null,
        $video  = null;

    /**
     * Init Carousel
     */
    function initCarousel() {
      if (!Modernizr.touchevents) {
        enableTouchMove = false;
      } else {
        enableTouchMove = true;
      }

      $(carousel).each(function(index){
        carouselSwiper = new Swiper($(this)[0], {
            speed: 1000,
            loop: true,
            nested: true,
            allowTouchMove: false,
            navigation: {
              nextEl: $(this).find('.js-carousel-next'),
              prevEl: $(this).find('.js-carousel-prev'),
            },
            pagination: {
              el: $(this).find('.js-carousel-pagination'),
              type: 'fraction',
            },
            on: {
              slideChange: function () {
                if($('.swiper-slide-active').find('.js-banner-video').length > 0) {
                  $video.prop('muted', true);
                  window.cache.isMute = true;

                  if(!$('.js-sound').hasClass('is-mute')) {
                    $('.js-sound').addClass('is-mute');
                  }
                }
              },
            }
        });
      });
    }

    /**
     * Init Carousel
     */
    function initCarouselText() {
      $(carouselText).each(function(index){
        carouselTextSwiper = new Swiper($(this)[0], {
          speed: 1000,
          loop: true,
          nested: true,
          effect: 'fade',
          allowTouchMove: false,
          navigation: {
            nextEl: $(this).closest(carousel).find('.js-carousel-next'),
            prevEl: $(this).closest(carousel).find('.js-carousel-prev'),
          },
          pagination: {
            el: $(this).closest(carousel).find('.js-carousel-pagination'),
            type: 'fraction',
          }
       });
      });
    }


    /**
     * Generic resize
     */
    function onResize() {
      // Example
      if (window.bp.getLastValue() !== window.bp.getValue()) {
        if (window.bp.getValue() === 'xl') {
        }

        if (window.bp.getValue() === 'lg') {
        }

        if (window.bp.getValue() === 'md') {
        }

        if (window.bp.getValue() === 'sm') {
        }

        if (window.bp.getValue() === 'xs') {
        }
      }
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(target) {

      // Caching
      carousel = '.js-carousel';
      carouselText = '.js-carousel-text';
      $video = $('.js-banner-video');

      initCarousel();
      initCarouselText();
      
      
      window.cache.$window.on('resize', Utils.debounce(onResize, 3000));
      // Initial call on load
      onResize();
    };

    self.initialize.apply(self, arguments);
    return self;
  }
  
  window.Components.Carousel = Carousel;
  
}(jQuery));
